export function getNextTutorialSection(
  sectionIds: readonly string[],
  completedSectionIds: Iterable<string>,
): string | null {
  const completed = new Set(completedSectionIds);
  return sectionIds.find((sectionId) => !completed.has(sectionId)) ?? null;
}

export function getValidTutorialSections(
  sectionIds: readonly string[],
  candidateSectionIds: Iterable<string>,
): string[] {
  const allowed = new Set(sectionIds);
  return Array.from(new Set(candidateSectionIds)).filter((sectionId) => allowed.has(sectionId));
}
